import { SavedViewsQuickFilter } from 'venn-utils';

const LEGACY_FILTER_VALUES: Record<string, SavedViewsQuickFilter> = {
  VENN_PROVIDED: SavedViewsQuickFilter.RISKPRO_PROVIDED,
};

export const migrateLegacyFilters = (filters: SavedViewsQuickFilter[]): SavedViewsQuickFilter[] =>
  filters.map((filter) => LEGACY_FILTER_VALUES[filter] ?? filter);
